if (!customElements.get("notifications-drawer")) {
    class NotificationsDrawer extends HTMLElement {
        constructor() {
            super();
            this.notificationsDialog = document.querySelector('#modal-notifications');
            this.notificationsIcon = this.querySelector('.header-notifications-opener');
            if (this.notificationsDialog) this.notificationsDialog.addEventListener('modalChanged', debounce(this.onModalChanged.bind(this), 0));
            this.init();
        }
    
        init() {
            const showNotificationsDialog = CookieUtility.getCookie('show_notifications_dialog');
            if (showNotificationsDialog && showNotificationsDialog == 'false') {
                this.notificationsIcon.classList.remove('bell-ring');
                this.notificationsIcon.classList.remove('has-notification');
            }
        }
    
        onModalChanged(event) {
            if (event.detail && event.detail.show) {
                this.notificationsIcon.classList.remove('bell-ring');
                this.notificationsIcon.classList.remove('has-notification');
                CookieUtility.setCookie('show_notifications_dialog', 'false', 1);
            }
        }
    }
    customElements.define('notifications-drawer', NotificationsDrawer);
}
